// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var PostingsController = function ($scope, $rootScope, $routeParams, PostingsExtended, AccountingStatus, gettext, PUtill,
                                   PostingStatus, gettextCatalog, DatepickerUtils) {

    $scope.accountingStatus = AccountingStatus.get();
    $scope.PostingStatus = PostingStatus;
    $scope.kindName = PUtill.getText('Type');
    $scope.statusName = PUtill.getText('Status');
    $scope.kind = '';
    $scope.IsExported = '';
    $scope.dateRange = { dateFrom: null, dateTo: null };

    $scope.filter = {
        debitorAccount: "",
        customerId: $routeParams.customerId || ""
    };

    $scope.needsAccountKindLabel = function (posting) {
        return posting && posting.Posting && posting.Group &&
            (posting.Group.PostingKind === 'Revenue' ||
            posting.Group.PostingKind === 'PrepaidCard' ||
            posting.Group.PostingKind === 'WriteOff') &&
            posting.Posting.TaxKind;
    };

    var getSearchParams = function () {
        let searchParams = { };
        if ($scope.kind) searchParams.kind = $scope.kind;
        if ($scope.IsExported) searchParams.IsExported = $scope.IsExported;

        DatepickerUtils.setSearchParamsWithStringRangeAndRaiseErrorIfNeeded($scope, searchParams, $scope.dateRange);

        return searchParams;
    };

    $scope.updateFilter = function (func) {
        $scope.postings = $scope.paginator(function (options, callback) {
            return PostingsExtended.query(options, function () {
                callback();
                if (func)
                    func();
                func = null;
            });
        }, getSearchParams(), 20);
    };
    
    function init() {
        if ($routeParams.filter) {
            $scope.search = $routeParams.filter;
        }
        if (!$scope.search) {
            $scope.search = "";
        }
        $scope.updateFilter();
    }

    $scope.error = false;

    $scope.setKind = function (status, defaultLabelName) {
        $scope.kind = status.replace(' ', '');
        $scope.kindName = PUtill.getText(defaultLabelName || status);
        $scope.updateFilter();
    };

    $scope.setStatus = function (status, defaultLabelName) {
        $scope.IsExported = status;
        $scope.statusName = PUtill.getText(defaultLabelName);
        $scope.updateFilter();
    };

    $scope.getStatusColor = function (status) {
        switch (status) {
        case PostingStatus.Draft:
            return 'gray';
        case PostingStatus.Exported:
            return 'green';
        case PostingStatus.Deleted:
            return 'red';
        case PostingStatus.Reversed:
            return 'orange';
        }
    }

    $scope.getStatusHoverText = function (status) {
        var message = '';
        switch (status) {
        case PostingStatus.Draft:
                message = gettext("Draft postings can still be altered as they have not yet been exported.");
            break;
        case PostingStatus.Exported:
                message = gettext("Exported postings can no longer be altered, as they have already been exported.");
            break;
        case PostingStatus.Deleted:
            return;
        case PostingStatus.Reversed:
                message = gettext("Reversed postings correct postings that have already been exported and can therefore no longer be changed.");
            break;
        }
        return gettextCatalog.getString(gettext(message));
    };

    gettext("Draft");
    gettext("Exported");
    gettext("Deleted");
    gettext("Reversed");

    gettext("Revenue");
    gettext("Deferral");
    gettext("ResolveDeferral");
    gettext("Payment");
    gettext("WriteOff");

    gettext("Net");
    gettext("Gross");
    gettext("Vat");

    init();
};
PostingsController.$inject = ["$scope", '$rootScope', '$routeParams', 'PostingsExtended', 'AccountingStatus', 'gettext',
    'PUtill', 'PostingStatus', 'gettextCatalog', 'DatepickerUtils'];
